import { render, staticRenderFns } from "./LinkdeConviteEvent.vue?vue&type=template&id=97a2f6ea&scoped=true"
import script from "./LinkdeConviteEvent.vue?vue&type=script&lang=js"
export * from "./LinkdeConviteEvent.vue?vue&type=script&lang=js"
import style0 from "./LinkdeConviteEvent.vue?vue&type=style&index=0&id=97a2f6ea&prod&lang=css"
import style1 from "./LinkdeConviteEvent.vue?vue&type=style&index=1&id=97a2f6ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a2f6ea",
  null
  
)

export default component.exports